var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container has-text-centered m-t-lg"},[_c('ABTest',{attrs:{"audioA":_vm.shuffledAudios[0],"audioB":_vm.shuffledAudios[1]},on:{"pick":_vm.onPick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }